import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["keyboradHighlight", "disabledDates"];
import React, { PureComponent } from 'react';
import Days from './Days';
import Weekdays from './Weekdays';
import ClassNames from 'classnames';
var MonthView = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(MonthView, _PureComponent);
  function MonthView() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = MonthView.prototype;
  _proto.renderWeekdays = function renderWeekdays() {
    var _this$props = this.props,
      activeStartDate = _this$props.activeStartDate,
      formatShortWeekday = _this$props.formatShortWeekday,
      locale = _this$props.locale,
      firstDayOfWeek = _this$props.firstDayOfWeek;
    return /*#__PURE__*/React.createElement(Weekdays, {
      locale: locale,
      activeStartDate: activeStartDate,
      formatShortWeekday: formatShortWeekday,
      firstDayOfWeek: firstDayOfWeek
    });
  };
  _proto.renderDays = function renderDays() {
    var _this$props2 = this.props,
      keyboradHighlight = _this$props2.keyboradHighlight,
      disabledDates = _this$props2.disabledDates,
      childProps = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    return /*#__PURE__*/React.createElement(Days, _extends({
      disabledDates: disabledDates
    }, childProps));
  };
  _proto.render = function render() {
    var keyboradHighlight = this.props.keyboradHighlight;
    var className = ClassNames('ap-calendar__month-view', {
      "keyboard-date-view-inner-highlight": keyboradHighlight
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, this.renderWeekdays(), this.renderDays())));
  };
  return MonthView;
}(PureComponent);
export { MonthView as default };